import { fetchSchema } from '$lib/stores/schema.svelte';
import { fetchContracts } from '$lib/stores/executor_contracts.svelte';
import { AUTH_ENABLED } from '$lib/auth/config';
import { restoreSession, isAuthenticated, getAccessToken } from '$lib/auth/auth.svelte';
import { connection } from '$lib/api/client';

// Disable SSR — layout imports browser-only modules (Thrift XHR, buffer).
export const ssr = false;

/**
 * Run before the layout renders. We have to restore the OIDC session here
 * (not in +layout.svelte's onMount) because fetchSchema fires a POST to /api
 * that needs the Bearer token; without the token deployed backend returns 401.
 * Skip fetchSchema entirely when auth is enabled but the user isn't signed in
 * yet — the login screen renders, and after callback load() re-runs with a
 * live session.
 */
export async function load() {
  if (AUTH_ENABLED) {
    restoreSession();
    const token = getAccessToken();
    if (token) connection.headers['Authorization'] = `Bearer ${token}`;
    if (!isAuthenticated()) return;
  }
  await Promise.all([fetchSchema(), fetchContracts()]);
}